import AnimatedComponent from '../abstracts/AnimatedComponent';
import Glide from '@glidejs/glide'

export default class SliderComponent extends AnimatedComponent {
    constructor(compEl) {
        super(compEl);

        const glideId = compEl.dataset.glideId
        const perView = compEl.dataset.glidePerView
        const homeSlider = !!compEl.dataset.glideHome

        if (homeSlider) {
            console.log('home')
            const glideInstance = new Glide(`[data-glide-id="${glideId}"]`, {
                autoplay: false,
                animationDuration: 1,
                rewindDuration: 0,
                animationTimingFunc: 'linear',
                perView,
                type: 'carousel'
            });

            const Example = function (Glide, Components, Events) {
                return {
                    modify(translate) {
                        return translate
                    }
                }
            }

            glideInstance.mutate([Example])

            const glideSlider = document.querySelector(`[data-glide-id="${glideId}"] .glide__slides`);
            const slideChildren = glideSlider.children;
            const slides = []
            for (const slide of slideChildren) {
                if (!slide.classList.contains("glide__slide--clone")) {
                    slides.push(slide)
                }
            }

            slides[0].classList.toggle('first-slide', true)
            slides[slides.length - 1].classList.toggle('last-slide', true)

            glideInstance.on('move', e => {
                const count = slides.length
                let index = glideInstance.index

                let prevIndex = index > 0 ? index - 1 : count - 1
                let nextIndex = index < count - 1 ? index + 1 : 0

                slides.forEach(slide => {
                    slide.classList.remove('c-slider-standard--prev-animation')
                    slide.classList.remove('c-slider-standard--next-animation')
                    slide.classList.remove('c-slider-standard--active-animation')

                    slide.classList.remove('c-slider-campaign--prev-animation')
                    slide.classList.remove('c-slider-campaign--next-animation')
                    slide.classList.remove('c-slider-campaign--active-animation')
                })

                slides[prevIndex].classList.add('c-slider-standard--prev-animation')
                slides[index].classList.add('c-slider-standard--active-animation')
                slides[nextIndex].classList.add('c-slider-standard--next-animation')

                slides[prevIndex].classList.add('c-slider-campaign--prev-animation')
                slides[index].classList.add('c-slider-campaign--active-animation')
                slides[nextIndex].classList.add('c-slider-campaign--next-animation')
            })

            glideInstance.mount();

            const glideArrows = document.querySelectorAll(`[data-glide-id="${glideId}"] .glide__arrow`)

            glideArrows.forEach(function (glideArrow) {
                glideArrow.addEventListener('click', function () {
                    glideInstance.go(glideArrow.dataset.glideDir)
                })
            })
        } else {
            console.log('no home')

            const glide = new Glide(`[data-glide-id="${glideId}"]`, {
                autoplay: false,
                perView,
            })
            glide.mount();

            const glideArrows = document.querySelectorAll(`[data-glide-id="${glideId}"] .glide__arrow`)

            glideArrows.forEach(function (glideArrow) {
                glideArrow.addEventListener('click', function () {
                    glide.go(glideArrow.dataset.glideDir)
                })
            })
            window.addEventListener('updateslide', (perview) => {
                console.log('update')
                glide.update({
                    perView
                })
            });
        }
    }

    init() {
        super.init();
    }
}
